export default "__VITE_ASSET__CXttgrbC__"